const workflowTypes = {
  FETCH_WORKFLOWS_REQUEST: 'SAF_APPLY_FETCH_OLD_WORKFLOWS_REQUEST',
  FETCH_WORKFLOWS_SUCCESS: 'SAF_APPLY_FETCH_OLD_WORKFLOWS_SUCCESS',
  FETCH_WORKFLOWS_FAILURE: 'SAF_APPLY_FETCH_OLD_WORKFLOWS_FAILURE',
};

export default workflowTypes;
